import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "../context/themeProvider";
import { DrawerProvider } from "../context/drawerProvider";
import { HasNavigatedProvider } from "../context/hasNavigated";
import { GpuTierProvider } from "../context/gpuTierProvider";
import ErrorBoundary from "./errorBoundary";

const AppWrapper = ({ children }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <CssBaseline enableColorScheme />
        <DrawerProvider>
          <GpuTierProvider>
            <HasNavigatedProvider>{children}</HasNavigatedProvider>
          </GpuTierProvider>
        </DrawerProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default AppWrapper;
